;((): void => {
    if (SiteInfo.starsSeparationActive) {
        if (SiteInfo.isMobileVersion) {
            import("./starsTopCreatorStripeMobile.css")
        } else {
            import("./starsTopCreatorStripePc.css")
        }
    }
})()
